import * as React from 'react';

import { Grid } from '@coursera/cds-core';

import { TrackChooser } from 'bundles/interactive-transcript';
import type { Track, TrackList } from 'bundles/interactive-transcript';


type Props = {
  tracks: TrackList;
  selectedTrack: Track;
  onTrackSelected: (track: Track) => void;
  itemId?: string;
  courseId?: string;
};

const ClipsTranscriptToolbar = ({ tracks, selectedTrack, onTrackSelected, itemId, courseId }: Props) => {
  return (
    <Grid container alignItems="center">
      <Grid item xs={12} sm="auto">
        <TrackChooser
          tracks={tracks}
          selectedTrack={selectedTrack}
          onTrackSelect={onTrackSelected}
          courseId={courseId}
          itemId={itemId}
        />
      </Grid>
    </Grid>
  );
};

export default ClipsTranscriptToolbar;
